<script>
import { mapState } from "vuex";
import {TheMask} from 'vue-the-mask'
import {EF_TRACKING_URL} from "@/paths/constants";
import SolarComponentTwilioSmsVerification from '@/components/SharedSteps/SharedComponentTwilioSmsVerification.vue'

export default {
  components: {TheMask , SolarComponentTwilioSmsVerification},
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState([
      'fields',
      'fieldsFromUrl',
      'fieldsFromStorage',
      'phoneError'
    ]),
    ...mapState('twilioSmsVerify', [
        'toggleModalWithSmsVerification',
        'approved'
    ])
  },

  data() {
    return {
      loading: false,
      phoneNumber: "",
      emptyPhoneFieldError: false,
      invalidPhoneFieldError: false,
      consentTime: "",
      localHour: null,
      changePhoneError: false,
    };
  },

  watch: {
    phoneNumber: function () {
      if (this.phoneNumber.length > 0) {
        this.$store.commit('twilioSmsVerify/RESET_TWILIO')
        this.$store.commit('SET_PHONE_ERROR', false)
      }
    },
    approved: function () {
      if (!this.phoneError && this.approved) {
        this.setAnswer()
      }
    }
  },

  async created() {
    if (this.prepare) {
      if (!(this.fieldsFromUrl["phone_number"] === undefined)) {
        this.phoneNumber = this.fieldsFromUrl["phone_number"].replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      } else if (!(this.fieldsFromStorage['phone_number'] === undefined)) {
        this.phoneNumber = this.fieldsFromStorage["phone_number"].replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      }

      const valid = await this.validate();

      if (!valid || this.phoneError) {
        this.$emit('show-this-step')
      } else {
        await this.setAnswer()
      }
    }
  },

  methods: {
    async setAnswer() {
      this.loading = true;
      this.consentOfTime();

      const valid = await this.validate();

      if (!valid || this.phoneError) {
        this.loading = false
        return false
      }
      await this.$store.dispatch("setAnswers", [
        {
          field: "phone_number",
          value: this.phoneNumber.replace(/[()\-\s]+/g, ""),
        },
        {
          field: "sms_verified",
          value: this.approved ? "yes" : "no"
        },
        {
          field: "consent_time",
          value: this.consentTime,
        },
        {
          field: "local_hour",
          value: this.localHour,
        }
      ]);
      this.$emit("next-step");
      // await this.progressionTracking();
    },

    consentOfTime() {
      var today = new Date()
        .toLocaleString("en-US", {
          timeZone: "America/New_York",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
          hourCycle: "h23"
        })
        .split(" ");
      var time = today[1];
      var mdy = today[0];
      mdy = mdy.split("/");
      var month = mdy[0];
      var day = mdy[1];
      var year = parseInt(mdy[2]);
      var formattedDate = year + "-" + month + "-" + day + " " + time;
      this.consentTime = formattedDate;

      var d = new Date();
      var n = d.getHours();
      this.localHour = n;
    },

    async validate() {
      if (!this.phoneNumber || this.phoneNumber.length === 0) {
        this.emptyPhoneFieldError = true;
        this.$store.commit('SET_PHONE_ERROR', true)
        return false
      }

      if (this.phoneNumber.length < 14) {
        this.invalidPhoneFieldError = true;
        this.$store.commit('SET_PHONE_ERROR', true)
        return false
      }
      const validRemote = await this.ipqsPhoneValidation()
      if (!validRemote) {
        // await this.failurePostBack()
        this.$store.commit('SET_PHONE_ERROR', true)
        return false
      }

      return true
    },

    showTwilioPhoneModal() {
      this.$store.commit('SET_PHONE_ERROR', true)

      document.body.classList.add('modal-open')
      this.$store.commit('twilioSmsVerify/TOGGLE_MODAL_WITH_SMS_VERIFICATION')

      if (this.toggleModalWithSmsVerification) {
        this.$store.dispatch('twilioSmsVerify/postPhone', this.phoneNumber)
      }
    },

    async ipqsPhoneValidation() {
      const ipqsURL = "https://validations.org31415.dev/api/validations/ipqs/phone"
      const phone = this.phoneNumber.replace(/[()\-\s]+/g, "")
      const response = await this.axios.post(ipqsURL, {
        phone
      })
      this.requestId = response.data.request_id

      if (!response.data.valid || !response.data.active) {
        this.$store.commit('SET_PHONE_ERROR', true)
        this.invalidPhoneFieldError = true;
        return false
      } else if (response.data.fraud_score > 85) {
        this.$store.commit('SET_PHONE_ERROR', true)
        this.changePhoneError = true
        return false
      }

      return true
    },

    async progressionTracking() {
      const eventID = this.customProps.trackProgress ? "43" : "64"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    async failurePostBack() {
      const eventID = this.customProps.trackFailure ? "74" : "76"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}&adv1=${this.requestId}`)
    },

    handlePhoneChange(phoneNumber) {
      this.$store.commit('SET_PHONE_ERROR', false)
      this.emptyPhoneFieldError = false;
      this.invalidPhoneFieldError = false;
      this.changePhoneError = false;

      this.$nextTick(() => {
        this.phoneNumber = phoneNumber
          .replace(/[^\d]+/g, "")
          .replace(" ", "")
          .replace("+", "")
          .replace(/(\d{3})(\d{3})(\d+)$/, "($1) $2-$3")
          .substring(0, 14);
      });
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <SolarComponentTwilioSmsVerification v-if="toggleModalWithSmsVerification" />
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question">
          Ok
          <span class="subtitle-question" style="font-size: 1.625rem">{{
            fields.First_Name
          }}</span
          >, last step. Let's see your options!<br />
          <span style="font-size: 1.375rem"
            >Confirm your mobile or home phone number.</span
          >
        </h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent="setAnswer('View My Results')"
        >
          <b-field
            class="has-text-left"
            :type="phoneError ? 'is-danger' : ''"
            :message="[
              { 'Please enter a phone number.': emptyPhoneFieldError },
              { 'This phone number is invalid.': invalidPhoneFieldError },
              { 'Please input a different phone number.': changePhoneError },
            ]"
          >
            <the-mask
              :class="{'is-danger': phoneError }"
              class="input mt-5"
              placeholder="(201) 555-0123"
              :mask="['(###) ###-####']"
              :loading="loading"
              @input="handlePhoneChange"
              v-model.trim="phoneNumber"
            />
          </b-field>
          <input
            type="submit"
            value="View My Results"
            class="input submitButton mt-5 input-submit"
            :loading="loading"
            :disabled="loading"
          />
          <label for="">
            <input type="hidden" id="leadid_tcpa_disclosure"/>
            <p class="terms has-text-justified mt-4">
              By clicking "View My Results", I confirm I have read and agreed to
              this website's <a href="/terms-of-service">Terms of Service</a> and
              <a href="/privacy-policy">Privacy Policy</a>, which includes a mandatory arbitration provision, and provide my express written
              consent via electronic signature authorizing <a href="/">AmericanFirstHealth.com</a>
              and one or more
              <a href="/partners"
                >insurance companies, their agents and marketing partners</a
              >
              to contact me about Insurance products and services (Including Medicare
              Advantage plans, Medicare Part D Prescription Drug Plans or Medicare Supplement
              Insurance Plans) to the number and email address I provided
              (including any wireless number). I further expressly
              consent to receive telemarketing emails, calls, text messages,
              pre-recorded messages, and artificial voice messages via an
              autodialed phone system, even if my telephone number is a mobile
              number that is currently listed on any state, federal or corporate
              “Do Not Call” list. I understand that my consent is not a condition
              of purchase of any goods or services and that standard message and
              data rates may apply. For California residents see
              <a href="/privacy-policy#ca-privacy-rights">here.</a>
            </p>
          </label>
        </form>
      </div>
    </div>
  </div>
</template>
